import { render, staticRenderFns } from "./StarRating.vue?vue&type=template&id=3dc81662&scoped=true&"
import script from "./StarRating.vue?vue&type=script&lang=js&"
export * from "./StarRating.vue?vue&type=script&lang=js&"
import style0 from "./StarRating.vue?vue&type=style&index=0&id=3dc81662&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc81662",
  null
  
)

export default component.exports